import React from 'react';
import {Box, Tooltip} from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import {useTranslation} from 'react-i18next';
import {
	useVoyageTemplateTitlesSingleVoyage
} from "@containers/singleVoyage/voyageTemplates/hooks/useVoyageTemplateTitlesSingleVoyage";
import SyncVoyagesVoyageTemplateModal
	from "@containers/singleVoyage/voyageTemplates/sync/SyncVoyagesVoyageTemplateModal";
import {sx} from './sx'

interface IProps {
	voyageTemplateId?: number | null
	templateDiverged?: boolean | null
	accountId: string | number
	/** a table cell: just the title, the marks as icons */
	compact?: boolean
	/** differs from the template as it is now; the mark opens the sync window */
	outdated?: boolean
	/** a crowded header: the template is an icon, its title in the tooltip */
	iconOnly?: boolean
}

/** Which template a voyage came from, and whether it was edited by hand since. Nothing for a voyage built by hand. */
const TemplateBadgeSingleVoyage = ({voyageTemplateId, templateDiverged, accountId, compact, outdated, iconOnly}: IProps) => {

	const {t} = useTranslation()
	const titles = useVoyageTemplateTitlesSingleVoyage(accountId)

	if (!voyageTemplateId) {
		return compact ? <>-----</> : <></>
	}

	const title = titles.get(voyageTemplateId)
	const label = title
		? (compact ? title : t('singleVoyage.voyageTemplate.badge.fromTemplate', {title}))
		: t('singleVoyage.voyageTemplate.badge.deleted')

	const withText = !compact && !iconOnly

	return (
		<Box sx={[sx.root, compact && sx.compact, iconOnly && sx.iconOnly]}>
			{iconOnly
				? <Tooltip title={label}>
					<Box component={'span'} sx={sx.mark}>
						<LayersOutlinedIcon sx={sx.markIcon}/>
					</Box>
				</Tooltip>
				: <Box component={'span'} sx={sx.title} title={label}>{label}</Box>}

			{templateDiverged && <Tooltip title={t('singleVoyage.voyageTemplate.badge.divergedHint')}>
                <Box component={'span'} sx={[sx.mark, sx.diverged]}>
                    <EditNoteIcon sx={sx.markIcon}/>
					{withText && t('singleVoyage.voyageTemplate.badge.diverged')}
                </Box>
            </Tooltip>}

			{outdated && <SyncVoyagesVoyageTemplateModal
                templateId={voyageTemplateId}
                accountId={accountId}
                button={<Tooltip title={t('singleVoyage.voyageTemplate.badge.outdatedHint')}>
					<Box component={'span'} sx={[sx.mark, sx.outdated]}>
						<SyncProblemIcon sx={sx.markIcon}/>
						{withText && t('singleVoyage.voyageTemplate.badge.outdated')}
					</Box>
				</Tooltip>}
            />}
		</Box>
	);
};

export default TemplateBadgeSingleVoyage;
